import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, WalletIcon, Building2Icon, HardHatIcon, PackageIcon, CalendarIcon } from 'lucide-react';
const services = [{
  icon: HomeIcon,
  title: 'Residential Pickup',
  description: 'Weekly curbside service with sturdy 96-gallon totes.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vWZvkcsjmDam4QwceZjY3R/ResidentialPickup.jpg',
  rotation: -90,
  link: '/services/residential-pickup'
}, {
  icon: WalletIcon,
  title: 'Budget Bag Service',
  description: 'Affordable waste removal without a long-term contract; perfect for seniors, seasonal residents, or light users. No minimums, no contracts. Bags are purchased in packs of ten from local businesses.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5WvzYSTcKMKg9dMTBVFpMR/BudgetBagService.jpg',
  link: '/services/budget-bag'
}, {
  icon: Building2Icon,
  title: 'Commercial Dumpsters',
  description: 'Available in 2, 4, 6, and 8-yard container sizes to fit the needs of any business.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4Tku44qLL3eVP7D6UtEer2/CommercialDumpsters.jpg',
  link: '/services/commercial-dumpsters'
}, {
  icon: HardHatIcon,
  title: 'Construction & Clean-Out Hauling',
  description: 'Reliable dumpsters for job sites and renovation projects.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2K6f4cRnzuB3bSEcm4rM8H/Construction-Clean-Out-Hauling.png',
  link: '/services/construction-hauling'
}, {
  icon: PackageIcon,
  title: 'Bulk Item Pickup',
  description: 'On-demand large item collection when you need it.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8qh7w8bd7QtYdXVnf41h1b/BulkItemPickup.png',
  link: '/services/bulk-item-pickup'
}, {
  icon: CalendarIcon,
  title: 'Temporary Dumpsters',
  description: 'Short-term rentals (2–8 yards) for clean-ups, moves, or special projects.',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3GWcmUk43FziaU7hby49mH/TemporaryDumpsters.png',
  link: '/services/temporary-dumpsters'
}];
export function Services() {
  return <section className="py-20 bg-[#E41C1C]" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-168">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-169">
            Our Services
          </h2>
          <p className="text-xl text-white max-w-3xl mx-auto" data-id="element-170">
            From weekly residential pickup to commercial dumpsters, we have the
            right solution for your waste management needs.
          </p>
        </div>
        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-171">
          {services.map((service, index) => {
          const IconComponent = service.icon;
          return <Link key={index} to={service.link} className="relative bg-white rounded-lg overflow-hidden hover:shadow-2xl transition-all duration-300 group h-[400px]" data-id="element-172">
                {/* Background Image */}
                {service.image && <div className="absolute inset-0 overflow-hidden" data-id="element-173">
                    <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" style={{
                transform: service.rotation ? `rotate(${service.rotation}deg) scale(1.5)` : undefined,
                transformOrigin: 'center center'
              }} data-id="element-174" />
                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" data-id="element-175"></div>
                  </div>}
                {/* Content */}
                <div className="relative h-full flex flex-col justify-end p-8" data-id="element-176">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-white rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#E41C1C] transition-colors duration-300" data-id="element-177">
                    <IconComponent className="w-8 h-8 text-[#E41C1C] group-hover:text-white transition-colors duration-300" data-id="element-178" />
                  </div>
                  {/* Title */}
                  <h3 className="text-2xl font-bold text-white mb-3" data-id="element-179">
                    {service.title}
                  </h3>
                  {/* Description */}
                  <p className="text-white text-sm leading-relaxed" data-id="element-180">
                    {service.description}
                  </p>
                </div>
              </Link>;
        })}
        </div>
        {/* Call to Action */}
        <div className="text-center mt-16" data-id="element-181">
          <button className="bg-white text-[#E41C1C] font-bold px-8 py-4 rounded hover:bg-gray-100 transition-colors text-lg shadow-lg" data-id="element-182">
            Request a Quote
          </button>
        </div>
      </div>
    </section>;
}